import { styled } from '@mui/material/styles'
import Box from '@/components/common/Box'
import { colors, typography, spacing } from '@/styles/designTokens'

export const PanelRoot = styled(Box)({
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
	// flex:1 fills DrawerBody on mobile/tablet so CartActionsFooter stays pinned to the bottom.
	// height:100% preserved for the desktop sidebar where the parent has an explicit height.
	flex: 1,
	height: '100%',
	minHeight: 0,
})

export const PanelHeader = styled(Box)({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	padding: `${spacing.lg}px ${spacing.xl}px`,
	minHeight: 40,
	borderBottom: `1px solid ${colors.divider}`,
	flexShrink: 0,
})

export const PanelHeading = styled('h2')({
	margin: 0,
	fontSize: typography.fontSizeXl,
	fontWeight: typography.fontWeightSemiBold,
	lineHeight: typography.lineHeightXl,
	letterSpacing: typography.letterSpacingNormalLg,
	color: colors.textPrimary,
})

export const PanelHeadingCount = styled('span')({
	color: colors.textSecondary,
})

export const ItemList = styled(Box)(({ theme }) => ({
	flex: '1 1 auto',
	// minHeight:0 — previously large minHeights (420/340px) forced the panel taller than the
	// constrained DrawerBody, pushing CartActionsFooter out of view. Flex layout fills the
	// available space; ItemList's overflowY:auto handles item overflow within that space.
	minHeight: 0,
	overflowY: 'auto',
	[theme.breakpoints.up('lg')]: {
		minHeight: 0,
	},
}))

export const EmptyState = styled(Box)(({ theme }) => ({
	flex: '1 1 auto',
	minHeight: 0,
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	gap: spacing.xs,
	padding: `${spacing.lg}px ${spacing.xl}px`,
	[theme.breakpoints.up('lg')]: {
		minHeight: 0,
	},
}))

export const EmptyStateText = styled('p')({
	margin: 0,
	fontSize: typography.fontSizeMd,
	fontWeight: typography.fontWeightRegular,
	lineHeight: typography.lineHeightMd,
	letterSpacing: typography.letterSpacingWide,
	color: colors.textPrimary,
	textAlign: 'center',
})

// Continuous #fafafa band: breakdown rows + amount due toggle.
// borderTop separates from the cart item list above.
export const OrderSummaryFooter = styled(Box)({
	display: 'flex',
	flexDirection: 'column',
	backgroundColor: colors.surfaceMuted,
	borderTop: `1px solid ${colors.border}`,
	flexShrink: 0,
})
